const _ = require("lodash");

export function filtroprincipalCalc(dat, datgastos, dataasistencias) {
  const filmarcaciones = dat.filter((n) => n.paraTarifa === "SI");
  const sumaMonto = _.sumBy(filmarcaciones, (i) =>
    Number(
      i.CostoHoraEmpresa *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraEmpresa * i.horasferiado * i.porcentajeferiado) / 100
    )
  );
  const sumaHoras = _.sumBy(filmarcaciones, (i) =>
    Number((i.horascalculadas + i.horashoraextra).toFixed(2))
  );

  const gastos = datgastos.filter((g) => g.paraTarifa === "SI");
  const montoGasto = _.sumBy(gastos, (g) => Number(g.monto));

  const asistencias = (dataasistencias || []).filter(
    (a) => a.paratarifa === "SI"
  );
  const montoAsistencias = _.sumBy(asistencias, (a) => Number(a.tarifa));

  return {
    liquidacion: filmarcaciones,
    sumaMonto: Math.round(sumaMonto),
    sumaHoras,
    gastos,
    montoGasto: Math.round(montoGasto),
    asistencias,
    montoAsistencias: Math.round(montoAsistencias),
  };
}

export function filtrohonorarioCalc(dat, datgastos, dataasistencias) {
  const filmarcaciones = dat.filter((n) => n.paraHonorario === "SI");
  const sumaMonto = _.sumBy(filmarcaciones, (i) =>
    Number(
      i.CostoHoraProfesional *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraProfesional * i.horasferiado * i.porcentajeferiado) / 100
    )
  );
  const sumaHoras = _.sumBy(filmarcaciones, (i) =>
    Number((i.horascalculadas + i.horashoraextra).toFixed(2))
  );

  const gastos = datgastos.filter((g) => g.paraHonorario === "SI");
  const montoGasto = _.sumBy(gastos, (g) => Number(g.monto));

  const asistencias = (dataasistencias || []).filter(
    (a) => a.parahonorario === "SI"
  );
  const montoAsistencias = _.sumBy(asistencias, (a) => Number(a.honorario));

  return {
    liquidacion: filmarcaciones,
    sumaMonto: Math.round(sumaMonto),
    sumaHoras,
    gastos,
    montoGasto: Math.round(montoGasto),
    asistencias,
    montoAsistencias: Math.round(montoAsistencias),
  };
}

export function filtroProfCalc(k, dat, datgastos, dataasistencias) {
  const filmarcaciones = dat.filter(
    (n) => n.paraHonorario === "SI" && n.IdUsuario == k
  );
  const sumaMonto = _.sumBy(filmarcaciones, (i) =>
    Number(
      i.CostoHoraProfesional *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraProfesional * i.horasferiado * i.porcentajeferiado) / 100
    )
  );
  const sumaHoras = _.sumBy(filmarcaciones, (i) =>
    Number((i.horascalculadas + i.horashoraextra).toFixed(2))
  );

  const gastos = datgastos.filter(
    (g) => g.paraHonorario === "SI" && g.idUsuario == k
  );
  const montoGasto = _.sumBy(gastos, (g) => Number(g.monto));

  const asistencias = (dataasistencias || []).filter(
    (a) => a.parahonorario === "SI" && a.asignado == k
  );
  const montoAsistencias = _.sumBy(asistencias, (a) => Number(a.honorario));

  return {
    liquidacion: filmarcaciones,
    sumaMonto: Math.round(sumaMonto),
    sumaHoras,
    gastos,
    montoGasto: Math.round(montoGasto),
    asistencias,
    montoAsistencias: Math.round(montoAsistencias),
  };
}